function getBaseUrl() {
	let baseUrl = process.env.REACT_APP_APIM_URL;
	if (baseUrl === undefined) {
		throw new Error("API Url is undefined");
	}

	if (baseUrl.substr(-1) !== "/") {
		baseUrl += "/";
	}
	return baseUrl;
}

type apiConfig = {
	apimUrl: string;
};

const config: apiConfig = {
	apimUrl: getBaseUrl(),
};

export default config;
